<div class="title">
  <span>{{ getTitle() }}</span>
</div>
<!-- CR classique -->
<div class="date" *ngIf="brouillon.type === 'cr-view' && brouillon.ot?.numero_ot">
  <span>
    <b>{{ brouillon.ot.numero_ot }}</b>
    -
    <b>
      <span *ngIf="brouillon.ot.site">
        {{ brouillon.ot.site.libelle_long }}
      </span>
    </b>
  </span>
</div>

<!-- CR NON Planifié envoyé -->
<div class="date" *ngIf="brouillon.type === 'cr-view' && !brouillon.ot.numero_ot">
  <span *ngIf="brouillon.ot.site">
    {{ brouillon.ot.site.libelle_long }}
  </span>
  <br />
  feature/
</div>
<!-- CR NON Planifié brouillon -->
<div class="date" *ngIf="brouillon.type === 'chrono-input'">
  <span>
    <b>{{ brouillon.site_name }}</b>
  </span>
</div>
<div class="date" *ngIf="brouillon.type === 'unplanned-ot'">
  <span>
    <b>{{ brouillon.site.libelle_long }}</b>
  </span>
  @if (brouillon.cr.commentaire_client) {
    <span class="ellipsis">Commentaire au client: {{ brouillon.cr.commentaire_client }}</span>
  }
  @if (brouillon.cr.commentaire_manager) {
    <span class="ellipsis">Commentaire interne: {{ brouillon.cr.commentaire_manager }}</span>
  }
</div>
@if (brouillon.type === 'cr-view') {
  @if (brouillon.commentaire_client) {
    <div class="date ellipsis">
      <span>Commentaire au client: {{ brouillon.commentaire_client }}</span>
    </div>
  }
  @if (brouillon.commentaire_manager) {
    <span class="date ellipsis">
      <span>Commentaire interne: {{ brouillon.commentaire_manager }}</span>
    </span>
  }
}
<div *ngIf="brouillon.type === 'cr-view'" class="date">
  @if (brouillon.intervention_date_fin) {
    <span>{{ brouillon.intervention_date_fin | date: 'dd/MM/yyyy à HH:mm' }}</span>
  } @else {
    <span>{{ 'CR.DATE_INCONNUE' | translate }}</span>
  }
</div>
<div *ngIf="brouillon.type === 'chrono-input' || brouillon.type === 'unplanned-ot'" class="date">
  @if (getDate()) {
    <span>{{ getDate() | date: 'dd/MM/yyyy à HH:mm' }}</span>
  } @else {
    <span>{{ 'CR.DATE_INCONNUE' | translate }}</span>
  }
</div>
